<template lang='pug'>
  .home(
    v-rc-loader="!loaded([...(mode !== 'user' ? ['userProfile'] : []), 'roles'])"
    :class="mode !== 'user' ? 'contact-page' : 'user-page'"
  )
    div(v-if="ready")
      v-layout.px-4.pt-4.grey.lighten-5
        v-flex(:class="hasSomePermissions ? 'xs3 mr-4' : 'lg3 xs12'")
          rc-user-contact.mb-4(:user="user" :title="mode !== 'user' ? 'CONTACT' : 'UTILISATEUR'" :class="mode !== 'user' ? 'contact-content-block' : 'user-content-block'")
            template(slot="prependActions")
              .idp-access-edit(v-if="$route.path.startsWith('/users')")
                v-dialog(v-if="user && user.has_idp_user" v-model="pwdResetDialog" width="30%")
                  v-card
                    v-card-text.pa-0
                      v-layout.column.pa-5.text-xs-center
                        .title Les instructions pour réinitialiser le mot de passe de l'accès STUDIO ont été envoyées à l'adresse :
                        .title.font-weight-bold.text-xs-center.mt-1.mt-4 {{user.email}}
                      v-layout.primary.justify-center.align-center.py-3.click(@click="pwdResetDialog = false")
                        .subheading.underline.white--text.font-weight-bold Fermer
                v-dialog(v-if="user && user.has_idp_user" v-model="reminderSentOpen" width="30%")
                  v-card
                    v-card-text.pa-0
                      v-layout.column.pa-5.text-xs-center
                        .title Un mail de relance a été envoyé à l'adresse :
                        .title.font-weight-bold.text-xs-center.mt-1.mt-4 {{user.email}}
                      v-layout.primary.justify-center.align-center.py-3.click(@click="reminderSentOpen = false")
                        .subheading.underline.white--text.font-weight-bold Fermer
                v-dialog(v-model="userCreateDialog" width="30%")
                  v-card
                    v-card-text.pa-0
                      v-layout.column.pa-5.text-xs-center
                        .title Les instructions pour initialiser l'accès STUDIO ont été envoyées à l'adresse :
                        .title.font-weight-bold.text-xs-center.mt-1.mt-4 {{user.email}}
                      v-layout.primary.justify-center.align-center.py-3.click(@click="userCreateDialog = false")
                        .subheading.underline.white--text.font-weight-bold Fermer
                v-dialog(v-model="newAccessRolesOpen" width="60%")
                  v-card
                    v-card-title.white--text.title.primary.elevation-4
                      v-layout.justify-center.align-center
                        v-flex.xs10.offset-xs1.text-xs-center CRÉER L'ACCÈS STUDIO
                        v-flex.xs1.text-xs-right
                          v-icon(large dark @click="newAccessRolesOpen = false") close
                    v-card-text
                      v-layout.justify-center
                        span.subheading.grey--text.text--darken-2 Sélectionnez les droits que vous voulez affecter à ce nouvel accès STUDIO.
                      rc-new-access-roles.mt-2(:user="user" ref="newAccessRoles")
                      v-layout.justify-end.pt-2
                        v-btn.success.mr-0.mb-0(@click="createAccount" flat dark) Créer l'accès STUDIO
                v-btn.success.mt-2(flat dark v-if="user.has_password" @click="resetPwd") Réinitialiser le mot de passe
                v-btn.success.mt-3(flat dark v-else-if="user.has_idp_user" @click="resendInitialisation") Envoyer un mail de relance
                v-btn.success.mt-0(flat dark v-else @click="openCreateStudioAccess") Créer l'accès STUDIO
            //- template(slot="prependActions" v-else-if="$route.path.startsWith('/users')")
              v-dialog(v-if="user && user.user" v-model="pwdResetDialog" width="30%")
                v-card
                  v-card-text.pa-0
                    v-layout.column.pa-5.text-xs-center
                      .title Les instructions pour réinitialiser le mot de passe de l'accès STUDIO ont été envoyées à l'adresse :
                      .title.font-weight-bold.text-xs-center.mt-1.mt-4 {{user.email}}
                    v-layout.primary.justify-center.align-center.py-3.click(@click="pwdResetDialog = false")
                      .subheading.underline.white--text.font-weight-bold Fermer
              v-btn.success.mt-3(flat dark v-if="user && user.user && user.user.has_password" @click="resetPwd") Réinitialiser le mot de passe
            template(slot="appendActions")
              v-layout.px-2.justify-end
                v-dialog(v-model="dialog" persistent max-width="450")
                  v-card
                    v-card-title.headline Confirmer la suppression.
                    v-card-text Cette opération ne pourra pas être annulée.
                    v-card-actions
                      v-spacer
                      v-btn(color="grey" dark depressed @click.native="dialog = false") Annuler
                      v-btn(
                        color="error"
                        depressed
                        @click.native="dialog = false"
                        @click="deleteContact(user)") Confirmer
                v-btn.error.mr-0.mb-2(flat dark @click="openDeleteConfirm") Supprimer
        v-flex.xs9.white.elevation-2.mb-4(v-if="hasSomePermissions")
          v-layout
            //- v-flex(:style="{ 'flex-basis': '20%' }")
            //-   rc-navigation-tree(:menu="mode === 'user' ? userMenu : contactMenu" :baseRoutes="['client_contact_detail', 'user_detail']")
            //- v-flex(:style="{ 'flex-basis': '80%' }" :class="mode !== 'user' ? 'contact-content-block' : 'user-content-block'")
            //-   div.pa-4.fill-height
            //-     router-view(v-if="ready")
            v-flex(:class="mode !== 'user' ? 'contact-content-block' : 'user-content-block'")
              rc-tab-nav.mx-4(:menu="mode === 'user' ? userMenu : contactMenu" :baseRoutes="['client_contact_detail', 'user_detail']")
              div.px-4.pb-4.pt-2(style="height: calc(100% - 48px)")
                router-view(v-if="ready && !creatingIdpAccess")
</template>

<script>
import axios from 'axios';
import RcUserContact from '@/components/RcUserContact/RcUserContact.vue';
import RcUserContactProfile from '@/components/RcUserContact/RcUserContactProfile.vue';
import RcUserRoles from '@/components/RcUserRoles/RcUserRoles.vue';
import RcNewAccessRoles from '@/components/RcUserRoles/RcNewAccessRoles.vue';
import RcBreadcrumb from '@/components/RcBreadcrumb/RcBreadcrumb.vue';
import RcSheets from '@/components/RcClients/RcSheets.vue';
import RcContentCard from '@/components/RcContentCard.vue';
import RcCustomFields from '@/components/RcClients/RcCustomFields.vue';
import RcNavigationTree from '@/components/RcNavigationTree.vue';
import RcTabNav from '@/components/RcTabNav.vue';
import apiContactService from '@/services/api/ambassador/contactService';
import apiUserService from '@/services/api/common/userService';
import apiIdpService from '@/services/api/common/idpService';

export default {
  components: {
    RcUserContact,
    RcUserContactProfile,
    RcUserRoles,
    RcNewAccessRoles,
    RcBreadcrumb,
    RcSheets,
    RcContentCard,
    RcCustomFields,
    RcNavigationTree,
    RcTabNav,
  },
  data() {
    return {
      dialog: false,
      addSheetOpen: false,
      availableSheets: [],
      availableSheetsLoading: false,
      pwdResetDialog: false,
      customFieldsLoading: false,
      ready: false,
      deleteFailDialog: false,
      userCreateDialog: false,
      reminderSentOpen: false,
      newAccessRolesOpen: false,
      creatingIdpAccess: false,
      contactMenu: [
        {
          title: "Gestion des droits",
          route: 'contact_roles',
          permissions: ['mes_utilisateurs_onglet_contact_roles'],
        },
      ],
      userMenu: [
        {
          title: "Gestion des droits",
          route: 'user_roles',
          permissions: ['mes_utilisateurs_onglet_user_roles'],
        },
      ],
    };
  },
  computed: {
    mode() {
      return this.$route.path.startsWith('/users') ? 'user' : 'contact';
    },
    hasSomePermissions() {
      const menu = this.mode === 'user' ? this.userMenu : this.contactMenu;
      menu.some(route => route.permissions.every(it => { return !!this.$store.state.app.user.roles.find(x => x.name === it) }));
      return menu.some(route => !route.permissions || !route.permissions.length || route.permissions.every(it => !!this.$store.state.app.user.roles.find(x => x === it)));
    },
    loaded(refs) {
      return refs => this.ready && refs.every(it => {
        if (!this.$refs[it]) {
          return true;
        }
        if (this.$refs[it]?.length) {
          return this.$refs[it][0] && this.$refs[it][0].loaded;
        }
        return this.$refs[it] && this.$refs[it].loaded;
      });
    },
    user() {
      return this.$store.state.contacts.selectedContact;
    },
  },
  mounted() {
    window.addEventListener('popstate', this.doubleBack);
    Promise.all([
      this.$store.dispatch(this.$route.path.startsWith('/users') ? 'users/getUser' : 'contacts/getContact', { contactId: this.$route.params.contactId }),
    ]).then(() => {
      this.ready = true;
      if (this.user.user && this.$store.state.app.destination.id === 1) {
        this.userMenu.push({
          title: "Accès STUDIO",
          route: 'user_ambassador_access',
          permissions: [],
        });
        this.contactMenu.push({
          title: "Accès STUDIO",
          route: 'contact_ambassador_access',
          permissions: [],
        });
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.doubleBack);
  },
  methods: {
    openCreateStudioAccess() {
      setTimeout(() => {
        this.newAccessRolesOpen = true;
      }, 0);
    },
    openDeleteConfirm() {
      setTimeout(() => { this.dialog = true; }, 0);
    },
    async resendInitialisation() {
      await apiIdpService[this.$route.path.startsWith('/users') ? 'resendUserSetPasswordEmail' : 'resendContactSetPasswordEmail'](this.user.id);
      setTimeout(() => {
        this.reminderSentOpen = true;
      }, 0);
    },
    async setNewAccessRoles(clientId, contactId, toRemoveIds) {
      await axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).post(`/v2/erp/clients/${clientId}/contact/${contactId}/access/roles`, { toRemoveIds });
    },
    async createAccount() {
      this.creatingIdpAccess = true;
      const { toRemoveIds } = this.$refs.newAccessRoles;
      const contactId = this.user.id;
      this.$refs.newAccessRoles.loading = true;
      const createSuccess = await apiIdpService[this.$route.path.startsWith('/users') ? 'createUserAccess' : 'createContactAccess'](contactId, toRemoveIds);
      if (createSuccess) {
        await apiIdpService[this.$route.path.startsWith('/users') ? 'setUserNewAccessRoles' : 'setContactNewAccessRoles'](contactId, toRemoveIds);
        this.userCreateDialog = true;
        this.$store.dispatch('contacts/editContact', { field: 'has_idp_user', value: true });
      }
      this.newAccessRolesOpen = false;
      this.creatingIdpAccess = false;
      this.ready = true;
    },
    getProfileTitle(type) {
      return this.$store.state.customFields.types.find(x => x.title === type)?.category;
    },
    async resetPwd() {
      await apiIdpService[this.$route.path.startsWith('/users') ? 'resetUserPassword' : 'resetContactPassword'](this.user.id);
      this.pwdResetDialog = true;
    },
    async deleteContact(user) {
      this.ready = false;
      const clientId = user.parent_id;
      this.mode === 'user' ? await apiUserService.deleteById(user.id) : await apiContactService.deleteById(user.id);
      const route = this.mode === 'user' ? { name: 'users_list' } : { name: 'client_contacts', params: { clientId: clientId } };
      this.$router.push(route);
      this.ready = true;
    },
    createUser() {
      const params = {
        login: this.user.email,
        user_partner_id: this.user.id,
        user_parent_id: this.user.parent_id,
      };
      this.$store.dispatch('users/createUser', params);
    },
    doubleBack() {
      if (['client_contact_detail', 'user_detail'].includes(this.$route.name)) {
        history.go(-1);
      }
    },
  },
};
</script>

<style lang="scss">
  .contact-content-block {
    height: calc(100vh - (var(--main-navigation-height) + 24px) - 24px);
    overflow-y: auto;
  }
  .user-content-block {
    height: calc(100vh - (var(--main-navigation-height) + 24px) - 24px);
    overflow-y: auto;
  }
  .user-page {
    height: calc(100vh - var(--main-navigation-height));
    overflow-y: auto;
  }
  .contact-page {
    height: calc(100vh - var(--main-navigation-height));
    overflow-y: auto;
  }
  .contact-profile-placeholder {
    height: 300px;
  }
  .home {
    .available-sheets {
      height: 500px;
      overflow-y: auto;
      .available-sheet {
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
</style>
